import { useState, useEffect, useCallback } from 'react';
import { getMeFavoritesV1 } from '@/services/platform/api/me-—-favorites/me-—-favorites';
import type { FavoriteListDto } from '@/services/platform/api/model';

export interface UseFavoriteListsResult {
  data: FavoriteListDto[];
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export function useFavoriteLists(): UseFavoriteListsResult {
  const [data, setData] = useState<FavoriteListDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getMeFavoritesV1();
      if (response.status === 200 && response.data) {
        setData(response.data);
      } else {
        setData([]);
      }
    } catch {
      // silent
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, isLoading, refetch };
}
